export default __webpack_public_path__ + "static/media/hot_water.b9846a0c.jpg";